// Module
var code = "<div class=\"sliding-list\"> <div class=\"content\"> <div class=\"list-summary\"></div> <div class=\"wizard-form\"> <div class=\"sliding-item-container\"></div> <div id=\"appwizard-footer\" class=\"p-24px\"></div> </div> </div> </div> ";
// Exports
export default code;